import React from 'react';
import ButtonGeneral from '../../../../components/buttons/ButtonGeneral';
import InputField from '../../../../components/InputField/InputField';

type Props = {
    filter: any;
    setFilter: (filter: any) => void;
    onSearch: () => void;
};

const AvailableChecklistFilter = ({ filter, setFilter, onSearch }: Props) => {
    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <InputField
                        type="text"
                        label="Buscar"
                        value={filter.search || ''}
                        onChange={(value) => setFilter({ ...filter, search: value })}
                        placeholder="Buscar por nombre..."
                        size="small"
                    />
                </div>
                <div className='col-md-auto'>
                    <div>
                        <ButtonGeneral
                            onClick={onSearch}
                            title="Buscar"
                            variant="outline"
                            size="small"
                            icon="fa-search"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AvailableChecklistFilter;

